import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=bc64699c&scoped=true&"
import script from "./goodsDetail.vue?vue&type=script&lang=js&"
export * from "./goodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=bc64699c&lang=less&"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&id=bc64699c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc64699c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc64699c')) {
      api.createRecord('bc64699c', component.options)
    } else {
      api.reload('bc64699c', component.options)
    }
    module.hot.accept("./goodsDetail.vue?vue&type=template&id=bc64699c&scoped=true&", function () {
      api.rerender('bc64699c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shop/goodsDetail.vue"
export default component.exports